import listTemplate from './views/list.tpl.html';
import editorTemplate from './views/editor.tpl.html';
import BillingNumberCirclesEditController from './controllers/edit-controller';
import BillingNumberCirclesCreateController from './controllers/create-controller';

angular
    .module('festzelt-os.billing.number-circles')
    .config([
        '$stateProvider',
        config
    ]);

function config($stateProvider) {
    $stateProvider
        .state('app.billing.number-circles', {
            abstract: true,
            url: 'number-circles',
            template: '<ui-view />',
            data: {
                pageTitle: 'NumberCircle'
            }
        })
        .state('app.billing.number-circles.index', {
            url: '',
            sticky: true,
            data: {
                showBackBtn: false,
                right: 'billing::number_circle-list'
            },
            templateUrl: listTemplate,
            controller: 'NumberCircleListCtrl',
            controllerAs: 'vm'
        })
        .state('app.billing.number-circles.create', {
            url: '/create',
            data: {
                right: 'billing::number_circle-create'
            },
            params: {
                store: undefined
            },
            templateUrl: editorTemplate,
            controller: BillingNumberCirclesCreateController,
            controllerAs: 'vm'
        })
        .state('app.billing.number-circles.edit', {
            url: '/{id}/edit',
            params: {
                store: undefined
            },
            data: {
                right: 'billing::number_circle-edit'
            },
            templateUrl: editorTemplate,
            controller: BillingNumberCirclesEditController,
            controllerAs: 'vm'
        });
}



// WEBPACK FOOTER //
// ./src/app/pages/billing/number-circles/number-circle-routes.js